// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2m3-Q","inputWrap":"Table_inputWrap__TdjIx","col":"Table_col__2qHBO","bmiTooltip":"Table_bmiTooltip__BrkcQ"};